import React from 'react';
import { useNavigate } from 'react-router-dom';

const KPICard = ({ title, count, timeFilter, trend, icon, color = 'green', onClick, path, action }) => {
  const navigate = useNavigate();

  const handleClick = (e) => {
    if (e.target.closest('.kpi-card-action')) return;
    if (path) {
      navigate(path);
    } else if (onClick) {
      onClick();
    }
  };

  const isClickable = Boolean(path || onClick);

  return (
    <div
      className={`kpi-card color-${color} ${isClickable ? 'kpi-card-clickable' : ''}`}
      onClick={isClickable ? handleClick : undefined}
      style={isClickable ? { cursor: 'pointer' } : {}}
    >
      <div className="kpi-card-top">
        <div className="kpi-icon-wrapper">
          {icon}
        </div>
        {action && (
          <div className="kpi-card-action" style={{ zIndex: 10 }}>
            {action}
          </div>
        )}
      </div>

      <h3 className="kpi-count">{count.toLocaleString()}</h3>
      <p className="kpi-title">{title}</p>
      {timeFilter && <span style={{ fontSize: '0.75rem', color: '#6b7280' }}>{timeFilter}</span>}
    </div>
  );
};

export const KPICardSkeleton = () => (
  <div className="kpi-skeleton">
    <div className="skeleton-line skeleton-icon" style={{ marginBottom: '1rem' }} />
    <div className="skeleton-line skeleton-count" />
    <div className="skeleton-line skeleton-title" />
    <div className="skeleton-line skeleton-badge" />
  </div>
);

export default KPICard;
